import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import React from 'react';

// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
let singletonClient = null;

export default (options?: any) => {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  if (singletonClient) {
    return singletonClient;
  } else {
    if (!options?.apiKey) {
      return;
    }
    singletonClient = bugsnag(options).use(bugsnagReact, React);
    return singletonClient;
  }
};
